module.exports = __webpack_public_path__ + "img/9791130603728.2da797f4.jpg";